import { TFunction } from 'i18next';
import { z } from 'zod';

export const getCategorySchema = (t: TFunction, isCreate: boolean) => {
  let base = z.object({
    title: z.string().min(1, t('common.validation.titleRequired')),
    description: z.string().min(1, t('common.validation.descriptionRequired')),
    visibleOnApp: z.boolean().default(false),
  });

  if (isCreate) {
    base = base.extend({
      typeTitle: z.string().min(1, t('common.validation.titleRequired')),
      typeVisibleOnApp: z.boolean().default(false),
    });
  }

  return base;
};
